import { module, IController, IComponentOptions } from 'angular';

import { ACCOUNT_SERVICE, AccountService } from 'core/account/account.service';

import './accountTag.less';

class AccountTagController implements IController {
  public account: string;

  public accountType: string;

  constructor(private accountService: AccountService) { 'ngInject'; }

  public $onInit(): void {
    this.accountService.challengeDestructiveActions(this.account).then((isProdAccount) => {
      this.accountType = isProdAccount ? 'prod' : this.account;
    });
  }

  public $onChanges(): void {
    this.$onInit();
  }
}

export class AccountTagComponent implements IComponentOptions {
  public bindings: any = {
    account: '<',
  };
  public controller: any = AccountTagController;
  public template = '<span class="account-tag account-tag-{{$ctrl.accountType}}">{{$ctrl.account}}</span>';
}

export const ACCOUNT_TAG_COMPONENT = 'spinnaker.core.account.accountTag';
module(ACCOUNT_TAG_COMPONENT, [
  ACCOUNT_SERVICE
])
  .component('accountTag', new AccountTagComponent());



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/account/accountTag.component.ts